import { Link } from 'react-router';
import { MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
import { FaLinkedin, FaGithub } from 'react-icons/fa';

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          {/* About */}
          <div className="col-span-1 md:col-span-2">
            <div className="mb-4 flex items-center space-x-2">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-linear-to-br from-blue-600 to-cyan-500">
                <span className="text-xl font-bold text-white">AK</span>
              </div>
              <span className="text-xl font-bold text-white">Alok Kumar</span>
            </div>
            <p className="mb-4 max-w-md text-gray-400">
              Senior Software Developer with over all 9 years of experience in
              building enterprise-scale applications using modern technologies
              and cloud platforms.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.linkedin.com/in/alokkumarcse"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-lg bg-gray-800 transition-colors hover:bg-blue-600"
              >
                <FaLinkedin className="h-5 w-5" />
              </a>
              <a
                href="https://github.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-lg bg-gray-800 transition-colors hover:bg-blue-600"
              >
                <FaGithub className="h-5 w-5" />
              </a>
              <a
                href="mailto:alokcontactmail@gmail.com"
                className="flex h-10 w-10 items-center justify-center rounded-lg bg-gray-800 transition-colors hover:bg-blue-600"
              >
                <MailIcon className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="mb-4 font-semibold text-white">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="transition-colors hover:text-white">
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="transition-colors hover:text-white"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="transition-colors hover:text-white"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/portfolio"
                  className="transition-colors hover:text-white"
                >
                  Portfolio
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="mb-4 font-semibold text-white">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <PhoneIcon className="mt-0.5 h-5 w-5 shrink-0" />
                <span>+91-9162337593</span>
              </li>
              <li className="flex items-start space-x-2">
                <MailIcon className="mt-0.5 h-5 w-5 shrink-0" />
                <span>support@alokweb.in</span>
              </li>
              <li className="flex items-start space-x-2">
                <MapPinIcon className="mt-0.5 h-5 w-5 shrink-0" />
                <span>Bangalore, India</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 border-t border-gray-800 pt-8 text-center text-sm text-gray-500">
          <p>
            &copy; {new Date().getFullYear()} Alok Kumar. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
